export default __webpack_public_path__ + "images/c1b1c0983723a0eaaf879e41f4072cbe.svg";